import React from 'react';
import { productDetails } from '../../data/productContent';
import { productImages } from '../../data/siteConfig';
export function ProductDetails() {
  return <section id="details" aria-labelledby="details-title" className="scroll-mt-16" data-id="element-213" data-mp="34gieq3gf3289">
      <div className="mx-auto grid max-w-page gap-12 px-5 py-20 md:px-10 lg:grid-cols-[1fr_1.4fr] lg:gap-20 lg:py-28" data-id="element-214" data-mp="2qkwv6bsydan8">
        <div data-id="element-215" data-mp="3ia9oncy28o4i">
          <h2 id="details-title" className="font-display text-4xl font-medium leading-tight text-ink md:text-[52px]" data-id="element-216" data-mp="3iajijbm87ffh">
            The details.
          </h2>
          <p className="mt-4 max-w-sm text-[17px] leading-relaxed text-ink-muted" data-id="element-217" data-mp="3n8kxbkcmcsl5">
            The essentials of the mask and kit. Full instructions are in the included user manual.
          </p>
          <figure className="mt-8 max-w-[405px]" data-id="element-218" data-mp="3dhqc8jb3zz1a">
            {/* Photo-only viewport of the supplied detail graphic. All technical and comfort claims stay outside the crop. */}
            <svg viewBox="0 133 405 284" width="405" height="284" role="img" aria-labelledby="details-photo-title" className="block h-auto w-full overflow-hidden rounded-md border border-line bg-canvas-deep" data-id="element-219" data-mp="9v9j6b9q0obe">
              <title id="details-photo-title" data-id="element-220" data-mp="1xu3qn8cfhozz">Close-up of the mask's side controls and USB charging port</title>
              <image href={productImages.detail.src} width="800" height="1372" data-id="element-221" data-mp="1t0hmk4kbytfs" />
            </svg>
            <figcaption className="mt-3 text-[14px] text-ink-muted" data-id="element-222" data-mp="26re2ovx2li5y">Side controls and charging port.</figcaption>
          </figure>
        </div>
        <dl className="border-t border-ink" data-id="element-223" data-mp="2gr4x6xlmrx61">
          {productDetails.map(row => <div key={row.label} className="grid gap-1 border-b border-line py-5 sm:grid-cols-[180px_1fr] sm:gap-6" data-id="element-224" data-mp="2bsaf5xvhmcmz">
              <dt className="text-[14px] text-ink-muted" data-id="element-225" data-mp="mcu94rcv171b">{row.label}</dt>
              <dd className="text-[16px] text-ink" data-id="element-226" data-mp="he96yme1sda8">{row.value}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}